import {Text} from '@primer/react-brand'
import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS, MARKS, type Document} from '@contentful/rich-text-types'
import {codeMarkRenderer} from '@github-ui/swp-core/components/contentful/shared/RichTextFieldRenderer'

/*
 * Renders rich text without paragraph wrappers.
 */
export const renderWithNoMarks = (heading: Document) => {
  return documentToReactComponents(heading, {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
    },
    renderMark: codeMarkRenderer,
  })
}

export const renderWithSpans = (heading: Document, className?: string) => {
  return documentToReactComponents(heading, {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <span className={className}>{children}</span>,
    },
  })
}

export const renderPoints = (heading: Document) => {
  return documentToReactComponents(heading, {
    renderMark: {
      [MARKS.BOLD]: text => <Text variant="default">{text}</Text>,
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Text as="p" variant="muted">
          {children}
        </Text>
      ),
    },
  })
}
